export default "__VITE_ASSET__DJbRjfQi__"